module.exports = ".info-box.bg-color > .info-box-content {\n  color: #fff;\n}\n"